module.exports = __webpack_public_path__ + "img/328-de9003.png";